import { createPinia } from 'pinia'

export default createPinia(
  // Setup Pinia
// https://pinia.esm.dev/
)
